export default "https://cdn-static.gokick.com/assets/0d39bc0fcec85c93d0d6a7d8f262b967dc26f977/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";